<template>
	<span
		class="inline-flex items-center gap-2 px-2.5 py-1.5 text-xs font-medium leading-5 tracking-[0.3px] rounded-[20px] whitespace-nowrap"
		:style="badgeStyle"
	>
		<svg
			width="14"
			height="14"
			viewBox="0 0 14 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			class="flex-shrink-0"
			aria-hidden="true"
		>
			<path
				d="M6.99996 12.8333C10.2216 12.8333 12.8333 10.2217 12.8333 6.99999C12.8333 3.77833 10.2216 1.16666 6.99996 1.16666C3.7783 1.16666 1.16663 3.77833 1.16663 6.99999C1.16663 10.2217 3.7783 12.8333 6.99996 12.8333Z"
				:stroke="palette.foreground"
				stroke-width="1.33"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M5.25 7.00001L6.41667 8.16668L8.75 5.83334"
				:stroke="palette.foreground"
				stroke-width="1.33"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
		<span class="block" :style="{ color: palette.foreground }">
			{{ $t('general.top-fit') || 'Strong Profile' }}
		</span>
	</span>
</template>

<script>
export default {
	name: 'TopFitBadge',
	props: {
		variant: {
			type: String,
			default: 'default',
			validator(value) {
				return ['default', 'declined'].includes(value)
			}
		}
	},
	computed: {
		palette() {
			return {
				background:
					this.variant === 'declined' ? '#F5F5F5' : '#E6EFF4',
				foreground: '#1B2C36'
			}
		},
		badgeStyle() {
			return {
				backgroundColor: this.palette.background,
				color: this.palette.foreground
			}
		}
	}
}
</script>
